import { render, staticRenderFns } from "./V2SalesAnalytics.vue?vue&type=template&id=f4335b84&scoped=true&"
import script from "./V2SalesAnalytics.vue?vue&type=script&lang=js&"
export * from "./V2SalesAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./V2SalesAnalytics.vue?vue&type=style&index=0&id=f4335b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4335b84",
  null
  
)

export default component.exports